import isEqual from 'lodash/isEqual';

export function deepDiff(oldObj = {}, newObj = {}) {
  return Object.keys(newObj).reduce((acc, key) => {
    const oldVal = oldObj[key];
    const newVal = newObj[key];

    if (isEqual(oldVal, newVal)) return acc;

    if (
      newVal &&
      typeof newVal === 'object' &&
      !Array.isArray(newVal) &&
      !(newVal instanceof Date)
    ) {
      const childDiff = deepDiff(oldVal || {}, newVal);
      if (Object.keys(childDiff).length) acc[key] = childDiff;
    } else {
      acc[key] = newVal;
    }
    return acc;
  }, {});
}
